/* eslint-disable quotes */
import { Component } from '@angular/core';
import { TableActionsTemplate } from 'src/app/@amiga-pyme/table-actions/templates/table-actions.template';
import { IEventAction } from 'src/app/@amiga-pyme/table-actions/components/ami-table-actions/ami-table-actions.interface';
import { PurchaseOrderInvoiceService } from './purchase-order-invoice.service';
import {
  IPurchaseOrderInvoice,
  PURCHASE_ORDER_INVOICE_TTL_ES
} from './purchase-order-invoice.interface';
import { PurchaseOrderService } from '../purchase-order/purchase-order.service';
import { MessageService } from 'primeng/api';

@Component({
  selector: 'pg-purchase-order-invoice',
  templateUrl: './purchase-order-invoice.component.html',
  providers: [MessageService]
})
export class PurchaseOrderInvoiceComponent extends TableActionsTemplate {
  idDocument: number;
  showOpenPurchaseOrderInvoiceCreate = false;
  confirmSettings = {};
  prueba = '';
  dataDocument: any;
  dataPurchaseOrder;
  purchaseOrderFiltered: any[];
  accumulatedQuantity: number;
  orderedQuantity: number;
  constructor(
    private serviceBase: PurchaseOrderInvoiceService,
    private purchaseOrderService: PurchaseOrderService,
    private messageService: MessageService
  ) {
    super('', serviceBase);
  }

  ngOnInit(): void {
    this.table.settings = {
      title: PURCHASE_ORDER_INVOICE_TTL_ES,
      columns: [
        { header: 'Orden de Compra', field: 'numberDocumentPurchaseOrder' },
        { header: 'Documento', field: 'numberDocument' },
        { header: 'Fecha de Factura', field: 'issue_at', pipe: 'Date' }
      ]
    };
    this.table.actionsHead = [
      {
        name: 'create',
        icon: 'pi pi-plus',
        class: 'p-button-rounded p-button-primary',
        pTooltip: 'Registrar Factura de Orden de Compra'
      }
    ];
    this.table.actions = [
      {
        name: 'see-details',
        icon: 'pi pi-eye',
        class: 'p-button-rounded p-button-primary',
        pTooltip: 'Ver detalles'
      },
      {
        name: 'delete',
        icon: 'pi pi-trash',
        class: 'p-button-rounded p-button-danger',
        pTooltip: 'Eliminar Factura'
      }
    ];
    this.initSubscriptions$();
  }

  initSubscriptions$() {
    this.suscriptionBase$ = this.serviceBase
      .getData$()
      .subscribe((data: IPurchaseOrderInvoice[]) => {
        this.table.data = data;
      });
    this.suscriptionBase$ = this.purchaseOrderService
      .getData$()
      .subscribe((data: []) => {
        this.dataPurchaseOrder = data;
      });
  }

  onReciveAction(event: IEventAction): void {
    const { data, action } = event;
    if (action === 'see-details') {
      this.dataDocument = data;
    }
    if (action === 'delete') {
      if (data.orderStatusId != 5) {
        this.confirmSettings = {
          message: 'Eliminar Factura',
          action: 'delete',
          data
        };
      } else {
        this.messageService.add({
          severity: 'warn',
          summary: 'Orden de compra ha sido completada',
          detail: 'No está permitido eliminar una facuta.'
        });
      }
    }
  }

  onReciveActionHead(event: IEventAction): void {
    if (event) {
      const { action, data } = event;
      if (action === 'create') {
        this.showOpenPurchaseOrderInvoiceCreate = true;
      }
    }
  }

  async actionConfirmed(event) {
    const { action, data } = event;
    if (action == 'delete') {
      this.message = { message: 'Eliminando facura...' };
      this.updatePurchaseOrder(data);

      this.message = await this.serviceBase.delete(data.id);
    }
  }

  updatePurchaseOrder(data) {
    this.purchaseOrderFiltered = [];
    this.purchaseOrderFiltered = this.dataPurchaseOrder.filter(
      (row) => row['id'] === data.purchaseOrderDocumentId
    );
    for (const product of data.products) {
      const id = this.purchaseOrderFiltered[0].products.findIndex(
        (item) => item['id'] == product['purchaseOrderDetailId']
      );

      this.purchaseOrderFiltered[0].products[id].quantity_invoiced -=
        product.quantity;
    }
    this.accumulatedQuantity = 0;
    for (const i in this.purchaseOrderFiltered[0].products) {
      this.accumulatedQuantity +=
        this.purchaseOrderFiltered[0].products[i].quantity_invoiced;
    }
    if (this.accumulatedQuantity == 0) {
      this.purchaseOrderFiltered[0].invoiceStatusId = 1;
    } else {
      this.purchaseOrderFiltered[0].invoiceStatusId = 2;
    }

    const fieldsToUpdate = {
      document: {
        providerId: this.purchaseOrderFiltered[0].providerId,
        paymentTermsId: this.purchaseOrderFiltered[0].paymentTermsId,
        taxId: this.purchaseOrderFiltered[0].taxId,
        orderStatusId: this.purchaseOrderFiltered[0].orderStatusId,
        receptionStatusId: this.purchaseOrderFiltered[0].receptionStatusId,
        invoiceStatusId: this.purchaseOrderFiltered[0].invoiceStatusId,
        delivery_at: this.purchaseOrderFiltered[0].delivery_at,
        numberDocument: this.purchaseOrderFiltered[0].numberDocument
      },
      products: this.purchaseOrderFiltered[0].products
    };
    this.purchaseOrderService.update(
      this.purchaseOrderFiltered[0].id,
      fieldsToUpdate
    );
  }

  ngOnDestroy() {
    this.unsubscribeBase();
  }
}
